export default __webpack_public_path__ + "static/media/personality-refresh-blue.6bbf9d00.svg";